

















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GCheckList',
  props: {
    imageUrl: String as PropType<string>,
    title: String as PropType<string>,
    price: Number as PropType<number>,
    isPriceUndecided: Boolean as PropType<boolean>,
    checked: Boolean as PropType<boolean>,
    brandId: {
      type: [String, null] as PropType<string | null>,
      default: null,
    },
    itemId: {
      type: [String, null] as PropType<string | null>,
      default: null,
    },
  },
  computed: {
    priceStr(): string {
      const { price, isPriceUndecided } = this.$props;
      console.log(isPriceUndecided);
      if (isPriceUndecided) return '価格未定';
      if (typeof price === 'number') {
        return `￥${price.toLocaleString()}`;
      }
      return '';
    },
  },
  methods: {
    // check() {
    //   this.$emit('check');
    // },
    click() {
      this.$emit('click');
    },
  },
});
